import React from 'react';
import { useSelector } from 'react-redux';
import { List, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { getMenu } from '../../../selectors';

import './Categories.scss';

const Categories = ({ onCategorySelect, horizontal, ...props }) => {
    const menu = useSelector(getMenu);
    const selectedId = useSelector(state => state.ui.selectedCategoryId) || (menu.hierarchy[0] || {}).id;
    // const isScrollingTimeoutHandler = useRef();

    // useEffect(() => {
    //     if (horizontal) {
    //         clearTimeout(isScrollingTimeoutHandler.current);
    //         console.log('scrolling....');

    //         // isScrollingTimeoutHandler.current = setTimeout(() => {
    //         //     var elmnt = document.getElementById(`category-listitem-${selectedId}`);
    //         //     if (elmnt) {
    //         //         console.log('scrollIntoView');
    //         //         elmnt.scrollIntoView({
    //         //             behavior: 'smooth',
    //         //             inline: 'center'
    //         //         });
    //         //     }
    //         // }, 500);
    //     }
    // }, [horizontal, selectedId]);

    if (horizontal) {
        return (
            <div className={'pi-categories-dropdown'}>
                <Dropdown
                    fluid
                    selection
                    floating
                    text={i18next.t('menu.selectCategory')}
                    value={selectedId}                    
                    options={menu.hierarchy.map(category => ({ key: category.id, value: category.id, text: category.name }))}
                    onChange={(e, { value }) => {
                        onCategorySelect(value);
                    }}
                />
            </div>
        );
    }

    return (
        <List
            link
            size="large"
            className={`pi-categories-list ${horizontal ? 'horizontal' : ''}`}
            {...props}
        >
            {menu.hierarchy.map(category => (
                <List.Item
                    key={category.id}
                    id={`category-listitem-${category.id}`}
                    as='a'
                    active={selectedId === category.id}
                    onClick={e => {
                        onCategorySelect(category.id);
                        e.preventDefault();
                    }}
                >
                    {/* <Image avatar src={category.imageUrl} /> */}
                    {category.name}
                </List.Item>
            ))}
        </List>
    );
};

export default Categories;
